import { Fragment, useEffect } from "react";
import { FormattedMessage as FM } from "react-intl";

import { CheckIcon, XMarkIcon } from "components/Icons";
import { Transition } from "@headlessui/react";
import { classNames } from "tools/ui";

export const Alert = ({
  text = "app.booking.alert_msg_default",
  color = "bg-red-200",
  position = "relative",
  onClose,
  show = false,
  children,
  autoRemove = false,
  icon = "xmark",
  duration = 5000,
  values,
}) => {
  useEffect(() => {
    if (autoRemove) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [show, onClose]);

  return (
    <Fragment>
      <Transition
        show={show}
        enter="transition-opacity duration-75"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-150"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
        className="w-full"
      >
        <div
          className={classNames(
            color,
            "p-4 pr-20 rounded-md flex items-center mb-4 shadow-md space-x-3 ",
            position,
          )}
        >
          {children ? (
            children
          ) : (
            <span>
              {icon === "xmark" ? (
                <XMarkIcon
                  className="w-6 h-6 cursor-pointer bg-red-600 fill-white hover:bg-red-700 rounded-full p-1 transition-colors"
                  onClick={onClose}
                />
              ) : (
                <CheckIcon
                  className="w-6 h-6 cursor-pointer hover:text-black bg-green-200 text-green-900 rounded-full p-1"
                  onClick={onClose}
                />
              )}
            </span>
          )}

          <span className="text-gray-800">
            {text ? <FM id={text} values={values} /> : null}
          </span>
        </div>
      </Transition>
    </Fragment>
  );
};
